import {BackgroundTaskId} from "platformed-client/types";
import {platformedClient} from ".";

export async function get(backgroundTaskId: BackgroundTaskId) {
  return await platformedClient.internalRequest("get", `/region/{region}/api/background_tasks/{background_task_id}`, {
    path: {background_task_id: backgroundTaskId},
    skipErrorHandler: true,
  });
}
